import { render } from "./SpotCard.vue?vue&type=template&id=6dd0133e"
import script from "./SpotCard.vue?vue&type=script&lang=js"
export * from "./SpotCard.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__